class FacetDeleteAll extends window.BAO.CustomElement() {
  constructor () {
    super()

    this.state = {
      root: window.theme.category
        ? window.theme.category.stateLayer.state
        : window.theme.searchResults.stateLayer.state,
    }

    this.eventBus = window.theme.category
      ? window.theme.category.eventBus
      : window.theme.searchResults.eventBus
  }

  connectedCallback () {
    this.addEventListener('click', this.handleClick)

    if (this.state.root.activeFacets.length === 0) {
      this.setAttribute('disabled', 'disabled')
    }
  }

  handleClick () {
    this.eventBus.publish('facets-list:remove-all-filters')
  }
}

window.customElements.define('facet-delete-all', FacetDeleteAll)
